import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

export default function BrowserWarning() {
  const [visible, setVisible] = useState(true);
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    // Simple and efficient browser checking.
    let isIE = /*@cc_on!@*/false || !!document.documentMode;
    setShowWarning(isIE);
  }, []);

  const hide = () => {
    setVisible(false);
  };

  if (!showWarning) return null;

  return (
    <Dialog
      open={visible}
      onClose={hide}
      aria-labelledby="browser-warning-title"
      aria-describedby="unsupported-browser-warning"
      disableEscapeKeyDown
      disableBackdropClick
    >
      <DialogTitle id="browser-warning-title">Unsupported Browser</DialogTitle>
      <DialogContent>
        <p id="browser-warning">
          We have detected that you are using a browser that we do not support.
          <br/>
          <br/>
          We recommend Chrome.
          <br/>
          <br/>
          You may continue using your current browser, but certain features may not operate correctly.
        </p>
      </DialogContent>
      <DialogActions>
        <Button onClick={hide}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}